import { defineStore } from 'pinia';
import apiGw from '@/services/apiGw';

import { Link } from '@/types/general';
import { Wallet } from '@/types/wallet';
import { getUidFromSelfLink } from '@/utils/links';

type Wallets = {
  selectedWalletUid?: string;
  wallets: { [key: string]: Wallet };
  walletsInContext: Map<string, Set<string>>;
};
export const useWalletsStore = defineStore('wallets', {
  state: (): Wallets => ({
    selectedWalletUid: undefined,
    wallets: {},
    walletsInContext: new Map()
  }),
  getters: {
    getWallets: (state) => {
      return Object.values(state.wallets);
    },
    getCurrentWallet: (state) => {
      return (state.selectedWalletUid && state.wallets[state.selectedWalletUid]) || Object.values(state.wallets)[0];
    }
  },
  actions: {
    selectWallet(uid: string) {
      this.selectedWalletUid = uid;
    },
    async getWalletDetails(link: Link): Promise<Wallet | undefined> {
      const walletUid = getUidFromSelfLink(link);
      const wallet = this.wallets[walletUid];

      if (wallet?._actions?.exportTransactions) {
        return wallet;
      }

      const response = await apiGw.get(link.uri);
      this.wallets[walletUid] = response.data;
      return this.wallets[walletUid];
    }
  }
});
